export var defaultProps = {
    className: '',
    type: 'border',
    size: 'normal',
    activeKey: '',
    defaultActiveKey: '',
    triggerEvent: 'click',
    onChange: function (key, tab) { },
    onBeforeChange: function (key, tab) { return true; },
};
export var defaultPanelProps = {
    className: '',
    style: undefined,
    disabled: false,
    forceRender: false,
    label: '',
};
